import { render } from "./ComponentTextMiningSentiment.vue?vue&type=template&id=7d81089e&scoped=true"
import script from "./ComponentTextMiningSentiment.vue?vue&type=script&lang=js"
export * from "./ComponentTextMiningSentiment.vue?vue&type=script&lang=js"

import "./ComponentTextMiningSentiment.vue?vue&type=style&index=0&id=7d81089e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d81089e"]])

export default __exports__